import {setNavTitle} from '../index.js';


if ($('.pagenav--vertical').length) {
	const config = require('./config.yaml');
	const throttle = require('throttle-debounce/debounce');
	const $upBtn = $('.js-scrollup');
	const scrollTopValue = 200;

	$(window).scroll(function () {
		if ($(window).scrollTop() < scrollTopValue && !$upBtn.hasClass('pagenav__scrollup--disabled')) {
			$upBtn.addClass('pagenav__scrollup--disabled');
		} else if ($(window).scrollTop() > scrollTopValue && $upBtn.hasClass('pagenav__scrollup--disabled')) {
			$upBtn.removeClass('pagenav__scrollup--disabled');
		}
	});

	setNavTitle(config);
	$(window).trigger('scroll');
}



// WEBPACK FOOTER //
// ./temp/components/page-nav/vertical/index.js